/**
 * Ключи query-параметров, значения которых маскируются перед отправкой в лог.
 * Сравнение ключей регистронезависимое.
 */
export const SENSITIVE_QUERY_KEYS = ['token', 'password', 'access_token', 'refresh_token'];

const MASK = '***';

/**
 * Собирает URL для записи в лог: путь + query-строка с замаскированными значениями
 * чувствительных параметров. Если query-параметров нет — возвращает только путь.
 */
export const buildMaskedUrl = (pathname: string, search: string): string => {
  if (!search) return pathname;

  const params = new URLSearchParams(search);
  const sensitive = new Set(SENSITIVE_QUERY_KEYS.map((key) => key.toLowerCase()));

  for (const key of [...params.keys()]) {
    if (sensitive.has(key.toLowerCase())) {
      params.set(key, MASK);
    }
  }

  const masked = params.toString();
  return masked ? `${pathname}?${masked}` : pathname;
};
